<ng-container *ngIf="!isResponse">
  <!-- configurazione righe -->
  <mat-card class="row-card mat-elevation-z2" style="margin-bottom: 16px;">
    <mat-card-header>
      <mat-card-title>{{ "generic.rows" | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div *ngFor="let row of displayRows; let i = index" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>Riga {{ i + 1 }}</mat-label>
          <input matInput [(ngModel)]="displayRows[i].title" [disabled]="!editable"/>
        </mat-form-field>
        <button mat-icon-button color="warn" (click)="removeRow(i)" *ngIf="displayRows.length > 2 && editable">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <button *ngIf="editable" mat-raised-button color="primary" (click)="addRow()">
        <mat-icon>add</mat-icon> {{ "pages.survey-details.add-row" | translate }}
      </button>
    </mat-card-content>
  </mat-card>

  <!-- configurazione colonne -->
  <mat-card class="column-card mat-elevation-z2 my-3" style="margin-bottom: 16px;">
    <mat-card-header>
      <mat-card-title>{{ "generic.columns" | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div *ngFor="let col of displayColumns; let j = index" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>Colonna {{ j + 1 }}</mat-label>
          <input [disabled]="!editable" matInput [(ngModel)]="displayColumns[j].title"/>
        </mat-form-field>
        <button mat-icon-button color="warn" (click)="removeColumn(j)" *ngIf="displayColumns.length > 2 && editable">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <button *ngIf="editable" mat-raised-button color="primary" (click)="addColumn()">
        <mat-icon>add</mat-icon>
        {{ "pages.survey-details.add-column" | translate }}
      </button>
    </mat-card-content>
  </mat-card>
</ng-container>

<ng-container *ngIf="isResponse && displayedColumns">
  <div class="table-wrapper">
    <table mat-table [dataSource]="displayRows" class="full-width">

      <!-- Colonna Domanda -->
      <ng-container matColumnDef="rowID">
        <th mat-header-cell *matHeaderCellDef sticky>{{ "generic.question" | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.title }}</td>
      </ng-container>

      <!-- Colonne Dinamiche -->
      <ng-container *ngFor="let column of displayColumns" [matColumnDef]="column.id">
        <th mat-header-cell *matHeaderCellDef sticky>{{ column.title }}</th>
        <td mat-cell *matCellDef="let row" fxLayoutAlign="center">
          <mat-radio-group
            [(ngModel)]="row.answer_id"
            (ngModelChange)="onAnswerChange(row)"
            name="row_{{ row.id }}">
            <mat-radio-button [value]="column.id"></mat-radio-button>
          </mat-radio-group>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="row-hover"></tr>
    </table>
  </div>
</ng-container>
